import {
  Component,
  ComponentRef,
  EventEmitter, inject,
  Input, OnChanges,
  OnInit,
  Output, PLATFORM_ID,
  SimpleChanges,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import {isPlatformBrowser} from "@angular/common";

@Component({
  selector: 'app-rich-text-editor-wrapper',
  templateUrl: './rich-text-editor-wrapper.component.html',
  styleUrl: './rich-text-editor-wrapper.component.scss'
})
export class RichTextEditorWrapperComponent implements OnInit, OnChanges {
  private readonly platformId = inject(PLATFORM_ID);

  @ViewChild("container", {read: ViewContainerRef}) container?: ViewContainerRef;

  @Input() content: string | undefined;
  @Input() disabled: boolean = false;
  @Input() key: any;
  @Output() contentChange: EventEmitter<string | undefined> = new EventEmitter<string | undefined>();

  private componentInstance?: any;

  constructor() {
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      import("../rich-text-editor/rich-text-editor.component").then(({RichTextEditorComponent}) => {
        const componentRef: ComponentRef<any> = this.container!.createComponent(RichTextEditorComponent);
        this.componentInstance = componentRef.instance;
        this.componentInstance.content = this.content;
        this.componentInstance.disabled = this.disabled;
        this.componentInstance.contentChange = this.contentChange;
        this.componentInstance.key = this.key;
      });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (isPlatformBrowser(this.platformId) && this.componentInstance) {
      this.componentInstance.content = this.content;
      this.componentInstance.disabled = this.disabled;
      this.componentInstance.contentChange = this.contentChange;
      this.componentInstance.key = this.key;
      this.componentInstance.ngOnChanges(changes);
    }
  }
}
